import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { UsersService } from "src/app/_services/admin/users.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { GlobalJobordersService } from "src/app/_services/global-joborders.service";
import { AuthenticationService } from "src/app/auth/authentication.service";

@Component({
    selector: "app-update-assignee",
    templateUrl: "./update-assignee.component.html",
    styleUrls: ["./update-assignee.component.scss"],
    standalone: false
})
export class UpdateAssigneeComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  data: any;
  assignedToOptions: any = [
    { name: "Order Owner", value: "owner" },
    { name: "User", value: "user" },
    { name: "Group", value: "group" },
  ];
  assigneeForm: FormGroup;
  userList: any = [];
  groupList: any = [];
  hideApplyToAllTask: boolean = false;
  orderOwnerUser: any = null;
  isModalFrom: string;

  constructor(
    public modalRef: BsModalRef,
    private bsModalServc: BsModalService,
    private userService: UsersService,
    private errorUtil: ErrorUtil,
    private languageTranslateService: LanguageTranslateService,
    private globalJOService: GlobalJobordersService,
    private auth : AuthenticationService
  ) {
    super();
    this.assigneeForm = new FormGroup({
      assignTo: new FormControl(null),
      assignToGroup: new FormControl(null),
      applyToAllTask: new FormControl(false),
    });
  }

  ngOnInit(): void {
    console.log("data in assignee modal", this.data);
    this.isModalFrom = this.data?.from;

    if (
      this.data.hideOrderOwnerOption != undefined &&
      this.data.hideOrderOwnerOption
    ) {
      this.assignedToOptions = this.assignedToOptions.filter(
        (option: any) => option.value != "owner"
      );
      this.assigneeForm.get("assignTo").setValue("user");
      this.onAssignToChange();
    }else{
      this.assigneeForm.get("assignTo").setValue("owner");
     
    }
    if(this.data.from && this.data.from == "jo-task-standalone"){
      this.hideApplyToAllTask = true;
    }
    this.getLanguageData();

    //if the modal is opened from task tab in view jo template page
    if (this.isModalFrom == 'jo-temp-task-standalone' && this.data.selectedItem){
      this.loadFormData();
    }
  }
  
  loadFormData(){
    this.assigneeForm.patchValue({
      assignTo: this.data.selectedItem.assignTo.id ? 'user' : 'group',
      assignToGroup: this.data.selectedItem.assignTo.id ? this.data.selectedItem.assignTo.id : this.data.selectedItem?.assignToGroup?.id
,
    })
  }
  //Language
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.getUsersList();
          this.getGroupsList();
        }
      })
    );
    console.log("translate", this.translate);
  }

  push(obs: any) {
    super.push(obs);
  }

  onAssignToChange() {
    if (
      this.assigneeForm.get("assignTo").value == "user" ||
      this.assigneeForm.get("assignTo").value == "group"
    ) {
      //this.getUsersList();
      this.assigneeForm.get("assignToGroup") ?.setValidators([Validators.required]);
      this.assigneeForm.get("assignToGroup")?.updateValueAndValidity();
    } else {
      this.assigneeForm.get("assignToGroup")?.clearValidators();
      this.assigneeForm.get("assignToGroup")?.updateValueAndValidity();
    }
  }

  onConfirmClick() {
    if (this.assigneeForm.invalid) {
      this.assigneeForm.markAllAsTouched();
      return;
    }

    let obj: any = {};
    if (this.assigneeForm.get("assignTo").value == "user") {
      let selectedUser: any = this.userList.find((user: any) => {
        return user.id == this.assigneeForm.get("assignToGroup").value;
      });
      obj["login"] = selectedUser ? selectedUser.login : null;
      obj["firstName"] = selectedUser ? selectedUser.firstName : null;
      obj["lastName"] = selectedUser ? selectedUser.lastName : null;

    } else if (this.assigneeForm.get("assignTo").value == "group") {
      let selectedGroup: any = this.groupList.find((group: any) => {
        return group.id == this.assigneeForm.get("assignToGroup").value;
      });
      obj["name"] = selectedGroup ? selectedGroup.name : null;
    }else{
      // order owner selected
      let selectedUser: any = this.orderOwnerUser ? this.orderOwnerUser[0] : null;
      console.log(selectedUser, 'selected order owner user',this.orderOwnerUser);
      obj["login"] = selectedUser ? selectedUser.login : null;
      obj["firstName"] = selectedUser ? selectedUser.firstName : null;
      obj["lastName"] = selectedUser ? selectedUser.lastName : null;
      this.assigneeForm.get("assignToGroup").setValue(selectedUser.id);
      
    }

    obj = { ...obj, ...this.assigneeForm.value, taskId: this.data.id };
    if (this.data.from == "jo-temp-task-standalone") {
      //call api and hide the modal if the modal was opened from Task tab in view JO template
      let payloadData: any = [];
      let assignToUser: any = {
        id: obj.assignToGroup,
        login: obj.login,
        firstName: obj.firstName,
        lastName: obj.lastName,
      };
      let assignToGroup: any = {
        name: obj.name,
        id: obj.assignToGroup,
      };

      payloadData.push({
        id: this.data.id,
        taskOrder: this.data.selectedItem.taskOrder,
        templateName: this.data.selectedItem.templateName,
        procedureId: this.data.selectedItem.procedureId ? this.data.selectedItem.procedureId : null,
        taskName: this.data.selectedItem.taskName,
        taskStatus: this.data.selectedItem.taskStatus,
        mandatory: this.data.selectedItem.mandatory,
        assignTo: obj.assignTo == "user" ? assignToUser : null,
        assignToGroup: obj.assignTo == "user" ? null : assignToGroup,
      });

      //new api for update assignnee
      let payload: any = {
        tmplJobOrderId: this.data.joTemplateId,
        tmplJobOrderTaskId: this.data.selectedItem.tmplJobOrderTaskId,
        userId: obj.assignTo == "user" ? obj.assignToGroup : null,
        userGroupId: obj.assignTo == "user" ? null : assignToGroup.id
      }
    
      if (obj.assignTo !== "user"){
        delete payload.userId;
        payload.userGroupId = obj.assignToGroup;
      }
      this.globalJOService
        .updateAssigneeOfTask(payload)
        .subscribe((res: any) => {
          if (res.status == 201 || res.status == 200) {
            this.errorUtil.setErrorMessage(
              200,
              this.translate?.general.messages.savedSuccessfully,
              null,
              "success",
              1000
            );

            this.bsModalServc.setDismissReason(
              JSON.stringify({ assignInfo: obj })
            );
            this.modalRef.hide();
          } else {
            this.errorUtil.setErrorMessage(
              res.status,
              null,
              res.error.title,
              "error",
              3000
            );
          }
        });
    } else {
      this.bsModalServc.setDismissReason(JSON.stringify({ assignInfo: obj }));
      this.modalRef.hide();
    }
  }

  getUsersList() {
    this.userService.getActiveUsers().subscribe(
      (res: any) => {
        console.log(res, "res in GET users api");
        // this.userList = _.filter(res, (o) => {
        //   return o.userType == null || o.userType.sysName !='DRIVER';
        // })
        this.userList = res;

        if(!this.data.hideOrderOwnerOption){
          this.orderOwnerUser = this.userList.filter((user: any) => user.id == this.auth.getUserId());
          console.log(this.orderOwnerUser, 'order owner user',this.auth.getUserId());
          
        }
      },
      (err: any) => {
        console.log(err, "error in GET users api");
        this.errorUtil.setErrorMessage(
          err.status,
          err.error ? err.error.title : null,
          err.error ? err.error.title : null,
          "error",
          2000
        );
      }
    );
  }

  get assignToLabel(): string {
    const value = this.assigneeForm.get('assignTo')?.value;
    if (!this.translate) return '';
    
    const map: any = {
      'user': this.translate?.jobOrder?.fields?.user?.singular,
      'group': this.translate?.setup?.users?.groups?.label.singular,
      'orderOwner': this.translate?.jobOrder?.fields?.orderOwner?.singular
    };
    
    return map[value] ?? value;
  }

  getGroupsList() {
    this.userService.getAlluserGroup().subscribe(
      (res: any) => {
        console.log(res, "res in GET groups api");
        // this.userList = _.filter(res, (o) => {
        //   return o.userType == null || o.userType.sysName !='DRIVER';
        // })
        this.groupList = res;
      },
      (err: any) => {
        console.log(err, "error in GET groups api");
        this.errorUtil.setErrorMessage(
          err.status,
          err.error ? err.error.title : null,
          err.error ? err.error.title : null,
          "error",
          2000
        );
      }
    );
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
